import TopMenu from 'components/mobile/common/Parts/TopMenu.js'
import React from 'react'
import styled from 'styled-components'

const Home = ({ className }) => {
  return (
    <StyledTop className={`${className}`}>
      <TopMenu />
    </StyledTop>
  )
}

const StyledTop = styled.div``

export default Home
